<template>
  <div class="row background_ivory">
    <div class="contents_area text_left">
      <div class="header_container">
        <h4 class="mb60">
          Main features & Benefits
        </h4>
      </div>
      <div class="feature_container">
        <div
            v-for="(arr, index) in feature"
            :key="index"
            class="feature_row mb40"
        >
          <div
              v-for="item in arr"
              :key="item.id"
              class="feature_item"
          >
            <div class="feature_img">
              <img :src="item.src" alt=""/>
            </div>
            <div class="feature_textarea">
              <h6 class="mb10">
                {{ item.title }}
              </h6>
              <div class="txt_body_1 --grey80">
                {{ item.desc }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FeatureAndBenefit',
  data() {
    return {
      feature : [
          [
            {
              id: 'test11',
              src: '/images/ic/feature/patient-management.svg',
              title: 'Effective & Efficient Patient Management',
              desc: 'The rebless™ Clinic dashboard organizes all profiles so providers can easily view and navigate patient data.'
            },
            {
              id: 'test22',
              src: '/images/ic/feature/assignment.svg',
              title: 'Therapy Regimen Assignment',
              desc: 'Prescribe reps, exercise time and levels of assistance or resistance to maximize patient recovery.'
            },
          ],
        [
          {
            id: 'test33',
            src: '/images/ic/feature/patient-engagement.svg',
            title: 'Increased Access & Patient Engagement',
            desc: 'Telemedicine capabilities improve communication with your patients and increase their access to care.'
          },
          {
            id: 'test44',
            src: '/images/ic/feature/reporting.svg',
            title: 'Treatment Tracking & Reporting',
            desc: 'All data from patient reblessTM exercise sessions is transferred to the Clinic app so activity and progress can be monitored and accessed at any time.'
          },
        ],
        [
          {
            id: 'test55',
            src: '/images/ic/feature/online-visits.svg',
            title: 'Online visits',
            desc: 'Decrease the likelihood of no- show appointments.'
          },
          {
            id: 'test66',
            src: '/images/ic/feature/saving.svg',
            title: 'Time & Cost Saving',
            desc: 'With the rebless.Clinic app, providers can view patient data and provide consultation from anywhere, and schedule and perform a telemedicine visit with the click of a button.'
          },
        ]
      ]
    }
  }
}
</script>
